import type { TableStats } from '@/services/table.service';

export interface TableKpis {
  totalTables: number;
  totalCapacity: number;
  activeTables: number;
  sections: number;
}

// Regression: GitHub issue #278 — "Table KPIs (Total Capacity, Active Tables,
// Sections) are computed from the current page only".
//
// The four KPI cards must reflect EVERY table at the location and stay constant
// across pages. They now come from the location-wide `/dining-tables/stats`
// aggregate, never from the current 20-row page slice. This maps that stats
// response into the KPI card values; before it loads (null) we show zeros
// rather than a page-derived guess.
export function deriveTableKpis(stats: TableStats | null): TableKpis {
  return {
    totalTables: stats?.total_tables ?? 0,
    totalCapacity: stats?.total_capacity ?? 0,
    activeTables: stats?.active_tables ?? 0,
    sections: stats?.sections ?? 0,
  };
}
